import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import ImPropTypes from "react-immutable-proptypes"
import { opId } from "swagger-client/es/helpers"
import { Iterable, fromJS, Map } from "immutable"

export default class OperationContainer extends PureComponent {
  constructor(props, context) {
    super(props, context)
    this.state = {
      tryItOutEnabled: false,
      executeInProgress: false
    }
  }

  static propTypes = {
    op: PropTypes.instanceOf(Iterable).isRequired,
    tag: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    method: PropTypes.string.isRequired,
    operationId: PropTypes.string.isRequired,
    showSummary: PropTypes.bool.isRequired,
    isShown: PropTypes.bool.isRequired,
    jumpToKey: PropTypes.string.isRequired,
    allowTryItOut: PropTypes.bool,
    displayOperationId: PropTypes.bool,
    isAuthorized: PropTypes.bool,
    displayRequestDuration: PropTypes.bool,
    response: PropTypes.instanceOf(Iterable),
    request: PropTypes.instanceOf(Iterable),
    security: PropTypes.instanceOf(Iterable),
    isDeepLinkingEnabled: PropTypes.bool.isRequired,
    specPath: ImPropTypes.list.isRequired,
    getComponent: PropTypes.func.isRequired,
    authActions: PropTypes.object,
    oas3Actions: PropTypes.object,
    oas3Selectors: PropTypes.object,
    authSelectors: PropTypes.object,
    specActions: PropTypes.object.isRequired,
    specSelectors: PropTypes.object.isRequired,
    layoutActions: PropTypes.object.isRequired,
    layoutSelectors: PropTypes.object.isRequired,
    fn: PropTypes.object.isRequired,
    getConfigs: PropTypes.func.isRequired
  }

  static defaultProps = {
    showSummary: true,
    response: null,
    allowTryItOut: true,
    displayOperationId: false,
    displayRequestDuration: false
  }

  mapStateToProps(nextState, props) {
    const { op, layoutSelectors, getConfigs } = props
    const { docExpansion, deepLinking, displayOperationId, displayRequestDuration, supportedSubmitMethods } = getConfigs()
    const showSummary = layoutSelectors.showSummary()
    const operationId = op.getIn(["operation", "__originalOperationId"]) || op.getIn(["operation", "operationId"]) || opId(op.get("operation"), props.path, props.method) || op.get("id")
    const isShownKey = ["operations", props.tag, operationId]
    const isDeepLinkingEnabled = deepLinking && deepLinking !== "false"
    const allowTryItOut = supportedSubmitMethods.indexOf(props.method) >= 0 && (typeof props.allowTryItOut === "undefined" ?
      props.specSelectors.allowTryItOutFor(props.path, props.method) : props.allowTryItOut)
    const security = op.getIn(["operation", "security"]) || props.specSelectors.security()

    return {
      operationId,
      isDeepLinkingEnabled,
      showSummary,
      displayOperationId,
      displayRequestDuration,
      allowTryItOut,
      security,
      isAuthorized: props.authSelectors.isAuthorized(security),
      isShown: layoutSelectors.isShown(isShownKey, docExpansion === "full" ),
      jumpToKey: `paths.${props.path}.${props.method}`,
      response: props.specSelectors.responseFor(props.path, props.method),
      request: props.specSelectors.requestFor(props.path, props.method)
    }
  }

  componentDidMount() {
    const { isShown } = this.props
    const resolvedSubtree = this.getResolvedSubtree()

    if(isShown && resolvedSubtree === undefined) {
      this.requestResolvedSubtree()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { response, isShown } = nextProps
    const resolvedSubtree = this.getResolvedSubtree()

    if(response !== this.props.response) {
      this.setState({ executeInProgress: false })
    }

    if(isShown && resolvedSubtree === undefined) {
      this.requestResolvedSubtree()
    }
  }

  toggleShown =() => {
    let { layoutActions, tag, operationId, isShown } = this.props
    const resolvedSubtree = this.getResolvedSubtree()
    if(!isShown && resolvedSubtree === undefined) {
      // transitioning from collapsed to expanded
      this.requestResolvedSubtree()
    }
    layoutActions.show(["operations", tag, operationId], !isShown)
  }

  onCancelClick=() => {
    this.setState({tryItOutEnabled: !this.state.tryItOutEnabled})
  }


   clearGetParameters=(pathMethod, parameters, operation,specPath) => {
      parameters.forEach((parameter) => {
        console.log("p"+parameter)
        let param =this.props.specSelectors.parameterWithMetaByIdentity(pathMethod, parameter)

        let defaultValue = param.get("schema").get("default")
        let examples = param.get("examples")
        if(examples!=undefined) {
          let example =  ''

            this.props.specActions.changeParamByIdentity(pathMethod,parameter,example,false)
  //           param.set("value", example)

          return
        }

        let exampleParam = param.get("example")
                if(exampleParam!=undefined) {
                  let newExampleParam =  ''

                    this.props.specActions.changeParamByIdentity(pathMethod,parameter,newExampleParam,false)
          //           param.set("value", example)

                  return
                }

        if(defaultValue!= undefined) {
          defaultValue = ''
          this.props.specActions.changeParamByIdentity(pathMethod,parameter,defaultValue,false)
          return
        }

        if(param.get("schema").get("example")!=undefined) {
          this.props.specActions.changeParamByIdentity(pathMethod,parameter,param.get("schema").get("example"),false)
          return
        }

        if(param.get("schema").get("default")!=undefined){
          this.props.specActions.changeParamByIdentity(pathMethod,parameter,param.get("schema").get("example"),false)
          return
        }


        this.props.specActions.changeParamByIdentity(pathMethod,parameter,undefined,false)
      })
    }

    clearRequestBody=(pathMethod, parameters, operation,specPath) => {
      /* let examples = operation.get("requestBody").get("content").get("application/json").get("examples")

      if(examples!=undefined) {
        this.props.oas3Actions.setRequestBodyValue({ value: Object.fromEntries(examples.entries().next().value[1].get("value")), pathMethod })
        return
      }

      let example = operation.get("requestBody").get("content").get("application/json").get("example")
      if(example!=undefined) {
         let myKeys = [];
              example.forEach((value, key) => myKeys.push(key));

              myKeys.forEach(x => example = example.set(x,''));
        this.props.oas3Actions.setRequestBodyValue({ value: Object.fromEntries(example), pathMethod })
        return
      } */

      let schema = operation.get("requestBody").get("content").get("application/json").get("schema").get('properties')
              if(schema!=undefined) {
                 /* let myKeys = [];
                      schema.forEach((value, key) => myKeys.push(key));

                      myKeys.forEach(x => schema = schema.set(x,'')); */
                // let schema1 = operation.get("requestBody").get("content").get("application/json").get("schema").get('properties');
                schema.forEach((value, key) => {
                                                  console.log(value.get('type'));
                                                  if(value.get('type') == 'array'){
                                                     console.log('inside if condition');
                                                    schema = schema.set(key,Array(1).fill(""));
                                                  }else if(value.get('type') == 'string'){
                                                    console.log('inside else if 1 condition');
                                                    schema = schema.set(key,'');
                                                  }else if(value.get('type') == 'integer'){
                                                    console.log('inside else if 2 condition');
                                                    schema = schema.set(key,'');
                                                  }else {
                                                    console.log('inside else if 2 condition');
                                                    schema = schema.set(key,'');
                                                  }
                                                });
                this.props.oas3Actions.setRequestBodyValue({ value: Object.fromEntries(schema), pathMethod })
                return
              }

       let schemaType = operation.get("requestBody").get("content").get("application/json").get("schema").get('type')
            if(schemaType=='array'){
            let arraySchema = operation.get("requestBody").get("content").get("application/json").get("schema").get('items').get('properties');
              arraySchema.forEach((value, key) => {
                                                                  console.log(value.get('type'));
        if(value.get('type') == 'array'){
           console.log('inside if condition');
        arraySchema = arraySchema.set(key,Array(1).fill(""));
        }else if(value.get('type') == 'string'){
          console.log('inside else if 1 condition');
          arraySchema = arraySchema.set(key,'');
        }else if(value.get('type') == 'integer'){
          console.log('inside else if 2 condition');
          arraySchema = arraySchema.set(key,'');
        }else {
          console.log('inside else if 2 condition');
          arraySchema = arraySchema.set(key,'');
        }
                                                                 });
                let newArraySchema = Array(1).fill(arraySchema);
                this.props.oas3Actions.setRequestBodyValue({ value: newArraySchema, pathMethod })
                return

            }

      this.props.oas3Actions.setRequestBodyValue({ value: undefined, pathMethod })
    }

    onClearAllClick=(pathMethod, parameters, operation,specPath) => {
      console.log("in clr"+specPath.get(2)+pathMethod+parameters)
      if(specPath.get(2)=="get"){
        this.clearGetParameters(pathMethod, parameters, operation,specPath)
        return
      }

      if(specPath.get(2)=="post"){
        this.clearRequestBody(pathMethod, parameters, operation,specPath)
        return
      }
    }



  resetGetParameters=(pathMethod, parameters, operation,specPath) => {
    parameters.forEach((parameter) => {
      console.log("p"+parameter)
      let param =this.props.specSelectors.parameterWithMetaByIdentity(pathMethod, parameter)

      let defaultValue = param.get("schema").get("default")
      let examples = param.get("examples")
      if(examples!=undefined) {
        let example = new Map(examples.entries().next().value[1]).get("value")
        if(example!= undefined) {
          this.props.specActions.changeParamByIdentity(pathMethod,parameter,example,false)
//           param.set("value", example)
        }
        return
      }

      if(defaultValue!= undefined) {
        this.props.specActions.changeParamByIdentity(pathMethod,parameter,defaultValue,false)
        return
      }

      if(param.get("schema").get("example")!=undefined) {
        this.props.specActions.changeParamByIdentity(pathMethod,parameter,param.get("schema").get("example"),false)
        return
      }

      if(param.get("schema").get("default")!=undefined){
        this.props.specActions.changeParamByIdentity(pathMethod,parameter,param.get("schema").get("example"),false)
        return
      }


      this.props.specActions.changeParamByIdentity(pathMethod,parameter,undefined,false)
    })
  }

  resetRequestBody=(pathMethod, parameters, operation,specPath) => {
    let examples = operation.get("requestBody").get("content").get("application/json").get("examples")

    if(examples!=undefined) {
      this.props.oas3Actions.setRequestBodyValue({ value: Object.fromEntries(examples.entries().next().value[1].get("value")), pathMethod })
      return
    }

    let example = operation.get("requestBody").get("content").get("application/json").get("example")
    if(example!=undefined) {
      this.props.oas3Actions.setRequestBodyValue({ value: Object.fromEntries(example), pathMethod })
      return
    }
let schema = operation.get("requestBody").get("content").get("application/json").get("schema").get('properties')
              if(schema!=undefined) {
                 /* let myKeys = [];
                      schema.forEach((value, key) => myKeys.push(key));

                      myKeys.forEach(x => schema = schema.set(x,'')); */
                // let schema1 = operation.get("requestBody").get("content").get("application/json").get("schema").get('properties');
                schema.forEach((value, key) => {
                                                  console.log(value.get('type'));
                                                  if(value.get('type') == 'array'){
                                                     console.log('inside if condition');
                                                      if(value.get('example')!=undefined){
                                                        let exmList = value.get('example')
                                                        schema = schema.set(key,exmList);
                                                     }else{
                                                         schema = schema.set(key,Array(1).fill("string"));
                                                     }
                                                  }else if(value.get('type') == 'string'){
                                                    console.log('inside else if 1 condition');
                                                    if(value.get('example')!=undefined){
                                                      schema = schema.set(key,value.get('example'));
                                                    }else{
                                                      schema = schema.set(key,'string');
                                                    }
                                                  }else if(value.get('type') == 'integer'){
                                                    console.log('inside else if 2 condition');
                                                     if(value.get('example')!=undefined){
                                                          schema = schema.set(key,value.get('example'));
                                                      }else{
                                                        schema = schema.set(key,0);
                                                      }
                                                  }else {
                                                    console.log('inside else if 2 condition');
                                                    schema = schema.set(key,'string');
                                                  }
                                                });
                this.props.oas3Actions.setRequestBodyValue({ value: Object.fromEntries(schema), pathMethod })
                return
              }
      let schemaType = operation.get("requestBody").get("content").get("application/json").get("schema").get('type')
      if(schemaType=='array'){
      let arraySchema = operation.get("requestBody").get("content").get("application/json").get("schema").get('items').get('properties');
        arraySchema.forEach((value, key) => {
                                                            console.log(value.get('type'));
                                                            if(value.get('type') == 'array'){
                                                               console.log('inside if condition');
                                                                if(value.get('example')!=undefined){
                                                                  let exmList = value.get('example')
                                                                  arraySchema = arraySchema.set(key,exmList);
                                                               }else{
                                                                   arraySchema = arraySchema.set(key,Array(1).fill("string"));
                                                               }
                                                            }else if(value.get('type') == 'string'){
                                                              console.log('inside else if 1 condition');
                                                              if(value.get('example')!=undefined){
                                                                arraySchema = arraySchema.set(key,value.get('example'));
                                                              }else{
                                                                arraySchema = arraySchema.set(key,'string');
                                                              }
                                                            }else if(value.get('type') == 'integer'){
                                                              console.log('inside else if 2 condition');
                                                               if(value.get('example')!=undefined){
                                                                    arraySchema = arraySchema.set(key,value.get('example'));
                                                                }else{
                                                                  arraySchema = arraySchema.set(key,0);
                                                                }
                                                            }else {
                                                              console.log('inside else 3 condition');
                                                              arraySchema = arraySchema.set(key,'string');
                                                            }
                                                          });
          let newArraySchema = Array(1).fill(arraySchema);
          this.props.oas3Actions.setRequestBodyValue({ value: newArraySchema, pathMethod })
          return

      }

    this.props.oas3Actions.setRequestBodyValue({ value: undefined, pathMethod })
  }

  onResetClick=(pathMethod, parameters, operation,specPath) => {
    console.log("in res"+specPath.get(2)+pathMethod+parameters)
    if(specPath.get(2)=="get"){
      this.resetGetParameters(pathMethod, parameters, operation,specPath)
      return
    }

    if(specPath.get(2)=="post"){
      this.resetRequestBody(pathMethod, parameters, operation,specPath)
      return
    }



  }

  onTryoutClick =() => {
    this.setState({tryItOutEnabled: !this.state.tryItOutEnabled})
  }

  onExecute = () => {
    this.setState({ executeInProgress: true })
  }

  getResolvedSubtree = () => {
    const {
      specSelectors,
      path,
      method,
      specPath
    } = this.props

    if(specPath) {
      return specSelectors.specResolvedSubtree(specPath.toJS())
    }

    return specSelectors.specResolvedSubtree(["paths", path, method])
  }

  requestResolvedSubtree = () => {
    const {
      specActions,
      path,
      method,
      specPath
    } = this.props


    if(specPath) {
      return specActions.requestResolvedSubtree(specPath.toJS())
    }

    return specActions.requestResolvedSubtree(["paths", path, method])
  }

  render() {
    let {
      op: unresolvedOp,
      tag,
      path,
      method,
      security,
      isAuthorized,
      operationId,
      showSummary,
      isShown,
      jumpToKey,
      allowTryItOut,
      response,
      request,
      displayOperationId,
      displayRequestDuration,
      isDeepLinkingEnabled,
      specPath,
      specSelectors,
      specActions,
      getComponent,
      getConfigs,
      layoutSelectors,
      layoutActions,
      authActions,
      authSelectors,
      oas3Actions,
      oas3Selectors,
      fn
    } = this.props

    const Operation = getComponent( "operation" )

    const resolvedSubtree = this.getResolvedSubtree() || Map()

    const operationProps = fromJS({
      op: resolvedSubtree,
      tag,
      path,
      summary: unresolvedOp.getIn(["operation", "summary"]) || "",
      deprecated: resolvedSubtree.get("deprecated") || unresolvedOp.getIn(["operation", "deprecated"]) || false,
      method,
      security,
      isAuthorized,
      operationId,
      originalOperationId: resolvedSubtree.getIn(["operation", "__originalOperationId"]),
      showSummary,
      isShown,
      jumpToKey,
      allowTryItOut,
      request,
      displayOperationId,
      displayRequestDuration,
      isDeepLinkingEnabled,
      executeInProgress: this.state.executeInProgress,
      tryItOutEnabled: this.state.tryItOutEnabled
    })

    return (
      <Operation
        operation={operationProps}
        response={response}
        request={request}
        isShown={isShown}

        toggleShown={this.toggleShown}
        onTryoutClick={this.onTryoutClick}
        onCancelClick={this.onCancelClick}
        onResetClick={this.onResetClick}
        onClearAllClick={this.onClearAllClick}
        onExecute={this.onExecute}
        specPath={specPath}

        specActions={ specActions }
        specSelectors={ specSelectors }
        oas3Actions={oas3Actions}
        oas3Selectors={oas3Selectors}
        layoutActions={ layoutActions }
        layoutSelectors={ layoutSelectors }
        authActions={ authActions }
        authSelectors={ authSelectors }
        getComponent={ getComponent }
        getConfigs={ getConfigs }
        fn={fn}
      />
    )
  }

}
